import { render, staticRenderFns } from "./BlankWithExtension.vue?vue&type=template&id=89cc1330&"
import script from "./BlankWithExtension.vue?vue&type=script&lang=js&"
export * from "./BlankWithExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports